import { useMemo } from 'react';
import { useNetwork } from '../network';
export const useNetworkRoles = () => {
    const { data: { roles }, } = useNetwork();
    const networkRoles = useMemo(() => {
        if (!roles) {
            return undefined;
        }
        return roles.reduce((dict, role) => ({
            ...dict,
            [role.type]: role,
        }), {});
    }, [roles]);
    return networkRoles;
};
//# sourceMappingURL=useNetworkRoles.js.map